import React, {Component} from 'react';
import MapGL, {Marker, NavigationControl} from '@urbica/react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import VCMarker from "../../search-results/components/ApartmentsMap/assets/Marker.png";

export default class extends Component {
    state = {
        latitude: null,
        longitude: null,
        zoom: 12
    }
    mapRef = React.createRef();

    componentDidMount() {
        this.setState({
            latitude: this.props.latitude,
            longitude: this.props.longitude,
        })
    }

    render() {
        const coordinates = this.props

        return <MapGL
            {...this.state}
            ref={this.mapRef}
            style={{width: '100%', height: '300px'}}
            mapStyle="mapbox://styles/mapbox/light-v9"
            accessToken={process.env.MIX_MAPBOX_ACCESS_TOKEN}
            onViewportChange={nextViewport => this.setState(nextViewport)}
            viewportChangeMethod='flyTo'
            viewportChangeOptions={{duration: 1000}}
        >
            <Marker
                longitude={coordinates.longitude}
                latitude={coordinates.latitude}
                offsetTop={-55}
            >
                <img
                    src={VCMarker}
                    alt="Marker VC"
                    style={{height: '55px', cursor: 'pointer'}}
                />
            </Marker>
            <NavigationControl showZoom position="bottom-right"/>
        </MapGL>
    }
}